import React, { useState } from 'react';
import { useMediaContext } from '../context/MediaContext';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase'

import { Avatar, Box, Divider, Drawer, IconButton, Link, List, ListItem, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import { Icon } from '@iconify/react';
import { AccountCircleOutlined, ArticleOutlined, Dehaze, Gavel, Logout, WorkspacePremium } from '@mui/icons-material';
import headicon from '../asset/headicon.png'

import { User } from 'model/User';

export type Props = {
  user: User
}
export default function Header(props: Props) {
  const { isPc } = useMediaContext()
  const [isDisplayDrawer, setIsDisplayDrawer] = useState(false)
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

    setIsDisplayDrawer(open);
  };

  const navigate = useNavigate()
  const handleSignout = () => {
    auth.signOut();
    navigate('/auth');
  }

  const sections = [
    { title: 'BO1', url: '/match?format=BO1', icon: 'akar-icons:sword' },
    // { title: 'BO3', url: 'bo3', not_yet: true, icon: 'akar-icons:double-sword' },
    { title: 'ランキング', url: '/ranking', icon: 'jam:crown' },
    { title: 'アナリティクス', url: '/analytics', icon: 'ic:baseline-auto-graph' },
  ];

  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider', pt: 1, pb: isPc ? 0 : 0.5 }}>
        <Link
          onClick={() => navigate('/')}
          sx={{cursor: 'pointer'}}
        >
          <img src={headicon} alt='' width={ isPc ? 180 : 120 } />
        </Link>
        <div style={{ flexGrow: 1 }} />
        {isPc ? (
          <IconButton size='large' onClick={() => navigate(`/mypage?id=${props.user.uuid}`)}>
            <Avatar
              src={props.user.profile_image_url}
              sx={{width: 50, height: 50}}
            />
          </IconButton>
        ) : (
            <>
              <IconButton onClick={() => setIsDisplayDrawer(true)}><Dehaze /></IconButton>
              <Drawer anchor='right' open={isDisplayDrawer} onClose={toggleDrawer(false)}>
                <Box
                  sx={{ width: 250 }}
                  role="presentation"
                  onClick={toggleDrawer(false)}
                  onKeyDown={toggleDrawer(false)}
                >
                  <List>
                    <ListItem
                      button
                      onClick={() => navigate(`/mypage?id=${props.user.uuid}`)}
                    >
                      <ListItemIcon sx={{minWidth: 30}}>
                        <AccountCircleOutlined />
                      </ListItemIcon>
                      <ListItemText primary='マイページ' />
                    </ListItem>
                    {sections.map((section, i) => (
                      <ListItem
                        key={i}
                        button
                        onClick={() => navigate(section.url)}
                      >
                        <ListItemIcon sx={{minWidth: 30}}>
                          <Icon icon={ section.icon } fontSize={24} />
                        </ListItemIcon>
                        <ListItemText primary={section.title} />
                      </ListItem>
                    ))}
                  </List>
                  <Divider />
                  <List>
                    <ListItem button onClick={() => navigate('/rule')}>
                      <ListItemIcon sx={{minWidth: 30}}>
                        <Gavel />
                      </ListItemIcon>
                      <ListItemText primary={'ルール'} />
                    </ListItem>
                    <ListItem button onClick={() => navigate('/subscription')}>
                      <ListItemIcon sx={{minWidth: 30}}>
                        <WorkspacePremium />
                      </ListItemIcon>
                      <ListItemText primary={'サブスクリプション'} />
                    </ListItem>
                    <ListItem button onClick={() => navigate('/privacypolicy')}>
                      <ListItemIcon sx={{minWidth: 30}}>
                        <ArticleOutlined />
                      </ListItemIcon>
                      <ListItemText primary={'プライバシーポリシー'} />
                    </ListItem>
                    <ListItem button onClick={handleSignout}>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <Logout />
                      </ListItemIcon>
                      <ListItemText primary={'ログアウト'} />
                    </ListItem>
                  </List>
                </Box>
              </Drawer>
            </>
        )}
      </Toolbar>
      {isPc &&  (
        <Toolbar
          component="nav"
          variant="dense"
          sx={{
            justifyContent: 'left',
            overflowX: 'auto',
          }}
        >
          {sections.map((section) => (
            <Link
              key={section.title}
              color='text.secondary'
              onClick={() => navigate(section.url)}
              sx={{
                mr: 3,
                textDecoration: 'none',
                cursor: 'pointer'
              }}
            >
              {section.title}
            </Link>
          ))}
          <div style={{ flexGrow: 1 }} />
          <Link
            color='text.secondary'
            onClick={() => navigate('/subscription')}
            sx={{ mr: 3, textDecoration: 'none', cursor: 'pointer' }}
          >
            サブスクリプション
          </Link>
          <Link
            color='text.secondary'
            onClick={() => navigate('/rule')}
            sx={{ mr: 3, textDecoration: 'none', cursor: 'pointer' }}
          >
            ルール
          </Link>
          <Link
            color='text.secondary'
            onClick={() => navigate('/privacypolicy')}
            sx={{ mr: 3, textDecoration: 'none', cursor: 'pointer' }}
          >
            プライバシーポリシー
          </Link>
          <IconButton onClick={handleSignout} sx={{color: '#e57373'}}><Logout /></IconButton>
        </Toolbar>
      )}
    </React.Fragment>
  );
}